module.exports = __webpack_public_path__ + "static/media/view5.829a73c7.jpg";